import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { Login } from "src/app/models/login.model";
import { AuthPayxService } from "src/app/services/payx/authPayx.service";
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { User } from "src/app/models/payx/user.model";
import { switchMap } from "rxjs/operators";
import { LoginService } from "src/app/services/login.service";
// import { MessagingService } from 'src/app/services/messaging.service';

@Component({
  selector: "app-physical-user-login",
  templateUrl: "./physical-user-login.component.html",
  styleUrls: ["./physical-user-login.component.scss"],
})
export class PhysicalUserLoginComponent implements OnInit {
  login: Login = new Login();
  loginIsValid: boolean = true;
  errorMessage: string = "";
  loadingToggle: boolean = false;
  booleanForCode: boolean = false;

  successToggle: boolean = false;

  MPToggle: boolean = true;

  registerForm: FormGroup;
  loginForm: FormGroup;
  forgotPasswordGroup: FormGroup;
  resetPassword: FormGroup;
  pass: string;
  showConfirmSide: boolean = false;
  showPasswordReset: boolean = false;
  showLoader: boolean = false;
  showConfirmCodeForgote: boolean = false;
  emailSend: string;
  passwordForLogin: string;
  confirmCodeResponseResetPAssword: number;
  allowPassowrdChange: boolean = false;
  cheked: boolean = false;

  showOTPForm: boolean = false;
  OTPFormGroup: FormGroup;

  interval: any;
  timeLeft: number = 10;
  showTimeLeft: boolean = true;

  @ViewChild("container") container: any;
  @ViewChild("signIn") signIn: any;
  @ViewChild("rulesCheckBox") rules: any;
  @ViewChild("confirmAcc") confirmAcc: any;
  @Input() mainLogin: boolean;

  constructor(
    private auth: AuthPayxService,
    private loginService: LoginService,
    private router: Router,
    // private messagingService: MessagingService,

    private formBuilder: FormBuilder,
    private aRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    if (localStorage.getItem("token")) this.router.navigateByUrl("user/qr");
    this.registerForm = this.formBuilder.group({
      firstName: ["", Validators.required],
      lastname: ["", [Validators.required]],
      password: ["", [Validators.required, Validators.minLength(8)]],
      confirmPassword: ["", [Validators.required, Validators.minLength(8)]],
      phoneNumber: ["", [Validators.required, Validators.minLength(8)]],
    });
    this.loginForm = this.formBuilder.group({
      userName: ["", Validators.required],
      password: ["", [Validators.required, Validators.minLength(8)]],
    });
    // this.messagingService.requestPermission();
    // this.messagingService.receiveMessage();
    // this.startTimer();
  }

  click() {
    let f = document.getElementsByClassName("front")[0] as HTMLElement;
    let b = document.getElementsByClassName("back")[0] as HTMLElement;
    f.classList.toggle("front-transform");
    b.classList.toggle("back-transform");
  }

  onSubBtnClick() {
    if (this.loadingToggle) return;
    this.loadingToggle = true;

    // if(!this.MPToggle)
    //   this.auth.login(this.login).subscribe(
    //     res=>{
    //       var transferID;
    //       var pxNumber;
    //       this.aRoute.queryParams.subscribe(params => {
    //         transferID = params['transferId'];
    //         pxNumber = params['pxNumber']
    //     });
    //         localStorage.setItem("token",res.headers.get('token'))
    //         if(transferID){
    //           this.router.navigateByUrl(`px_transfer/${transferID}`);
    //           return
    //         }
    //         else if(pxNumber){
    //           localStorage.setItem('c2f817aaf4604172039825c35853fec90c03d5f3',"2")
    //           this.router.navigateByUrl(`ecommerce_pay/webX?pxNumber=${pxNumber}`);
    //           return
    //         }
    //         // this.router.navigateByUrl(`physical-user/activate?phone=${this.login.username}`);
    //         this.router.navigateByUrl("physical-user/payment-cards");
    //     },
    //     err=>{
    //       if(err.status==302)
    //         this.router.navigateByUrl(`physical-user/activate?phone=${this.login.username}`);

    //       this.loginIsValid=false;
    //       this.loadingToggle=false;
    //       this.errorMessage='Incorrect username or password'
    //     }
    //   )
    // else
    this.loginService.login(this.login).subscribe(
      (res) => {
        if (res.status == 202) {
          this.router.navigate(["activate-account"], {
            queryParams: { token: res.headers.get("token") },
          });
          return;
        }
        localStorage.setItem("token", res.headers.get("token"));
        localStorage.setItem("id", res.body["merchantUserId"]);
        // let obj = res.body['merchants']
        // this.dataEx.updateObj(obj)
        this.router.navigateByUrl("user/qr");
      },
      (err) => {
        if (err.status == 401) {
          this.errorMessage = err.error;
          this.loadingToggle = false;
          this.loginIsValid = false;
        } else if (err.status == 400) {
          // this.errorMessage = err.error;
          this.errorMessage = "Incorrect username or password";
          this.loadingToggle = false;
          this.loginIsValid = false;
        } else if (err.status == 410) {
          this.errorMessage =
            "User is in use in another device, please logout ";
          this.loadingToggle = false;
          this.loginIsValid = false;
        } else {
          this.loadingToggle = false;
          this.loginIsValid = false;
        }
      }
    );
  }

  setNewPassword() {
    console.log(this.OTPFormGroup.get("password").value);
    console.log(this.OTPFormGroup.get("confirmPassword").value);
    this.showOTPForm = !this.showOTPForm;
  }

  register() {
    var user: User = {
      id: -1,
      firstname: this.registerForm.get("firstName").value,
      lastname: this.registerForm.get("lastname").value,
      phone: this.registerForm.get("phoneNumber").value,
      password: this.registerForm.get("password").value,
    };
    this.auth.register(user).subscribe(
      (res) => {
        this.registerForm.disable();
        this.booleanForCode = true;
        this.startTimer();
        // this.router.navigateByUrl(`physical-user/activate?phone=${this.registerForm.get('phoneNumber').value}`);
      },
      (err) => {}
    );
  }

  onCodeChanged() {}
  onCodeCompleted(event) {
    this.auth
      .activateUser(this.registerForm.get("phoneNumber").value, event)
      .subscribe((res) => {
        //
        this.successToggle = true;
      });
  }

  isValid() {
    return (
      this.registerForm.get("firstName").valid &&
      this.registerForm.get("lastname").valid &&
      this.registerForm.get("password").valid &&
      this.registerForm.get("confirmPassword").valid &&
      this.registerForm.get("phoneNumber").valid &&
      this.registerForm.get("password").value ==
        this.registerForm.get("confirmPassword").value
    );
  }

  isValidPass() {
    return (
      this.registerForm.get("password").value ==
      this.registerForm.get("confirmPassword").value
    );
  }

  startTimer() {
    this.showTimeLeft = true;
    this.timeLeft = 300;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.showTimeLeft = false;
        clearInterval(this.interval);
      }
    }, 1000);
  }

  getActivationCode() {
    this.auth
      .sendActivationCode(this.registerForm.get("phoneNumber").value)
      .subscribe((res) => {
        this.startTimer();
      });
  }

  getTimeLeft() {
    return new Date(this.timeLeft * 1000).toISOString().substr(14, 5);
  }

  onOkClick() {
    this.login.username = this.registerForm.get("phoneNumber").value;
    this.login.password = this.registerForm.get("password").value;
    this.onSubBtnClick();
  }

  // Rules
  clickCheckbox() {
    if (!this.cheked) this.rules["nativeElement"].click();
  }
  toggleEditable(event) {
    if (event.target.checked) {
      this.cheked = true;
    } else this.cheked = false;
  }

  rightPanelActive() {
    this.MPToggle = !this.MPToggle;
    this.container["nativeElement"].classList.add("right-panel-active");
  }

  rightPanelDective() {
    this.MPToggle = !this.MPToggle;
    this.container["nativeElement"].classList.remove("right-panel-active");
  }

  onFgBtnClick() {
    this.router.navigateByUrl("physical-user/forgot-password");
  }
}
